module.exports = __webpack_public_path__ + "static/media/curriculum_bg.885164a9.png";